import { useState, useEffect} from 'react';
import './InitialPrompt.css'; // Reuse existing styles or create new ones

const InitialPrompt = ({ onNext, initialScenario = '' }) => {
  const [scenario, setScenario] = useState(initialScenario || '');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (initialScenario) {
      setScenario(initialScenario);
    }
  }, [initialScenario]);

  const handleNext = async () => {
    if (!scenario.trim()) return;
    
    setIsLoading(true);
    try {
      await onNext({ scenario });
    } catch (error) {
      console.error('Error proceeding:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="initial-prompt-container">
      <div className="initial-prompt-header">
        <img src="/KURA-logo.png" alt="KURA Logo" className="kura-logo" />
      </div>

      <div className="prompt-content-simple">
        <h1 className="prompt-title">What are we creating today?</h1>
        
        <div className="input-group">
          <label className="input-label">Scenario / Idea</label>
          <textarea 
            className="textarea-input-large"
            placeholder="e.g. Interior design and seating arrangement for a modern coffee shop."
            value={scenario}
            onChange={(e) => setScenario(e.target.value)}
            rows={4}
          />
        </div>

        <div className="prompt-footer">
          <button 
            className="generate-button"
            onClick={handleNext}
            disabled={!scenario.trim() || isLoading}
          >
            {isLoading ? 'Analyzing...' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InitialPrompt;
